import 'ui-core/widgets/table-of-content/js/table-of-content';
export default class TableOfContent {
    classList = {
        hidden: 'hidden',
    };

    selectors = {
        menuBookTab: '.menuBook--tab',
        authorBio: '#authorBio',
        bookReviews: '#bookReviews',
        abstractPreviewZoom: '.abstract-preview__zoom',
        abstractLastFocus: '[data-lastFocus]',
        readCubeSharing: '.readCube-sharing',
        shareCtrl: '.share__ctrl',
        shareAccessCtrl: '.share-access__ctrl',
        dropBlockHolder: '.dropBlock__holder',
        tocAbstractPreview: '.table-of-content .abstract-preview',
    };

    elements = {
        menuBookTab: null,
        abstractPreviewZoom: null,
        readCubeSharing: null,
        shareCtrl: null,
        tocAbstractPreview: null,
    };

    constructor() {
        this.setElements();
        this.eventListeners();
        this.onReady();
        this.onLoad();
    }

    setElements() {
        this.elements.menuBookTab = document.querySelector(this.selectors.menuBookTab);
        this.elements.abstractPreviewZoom = UX.utils.convertToArray(
            document.querySelectorAll(this.selectors.abstractPreviewZoom)
        );
        this.elements.readCubeSharing = document.querySelector(this.selectors.readCubeSharing);
        this.elements.shareCtrl = document.querySelector(this.selectors.shareCtrl);
        this.elements.tocAbstractPreview = UX.utils.convertToArray(
            document.querySelectorAll(this.selectors.tocAbstractPreview)
        );
    }

    eventListeners() {
        // @todo: Replace jquery fancybox with another js plugin, so we can git rid of jquery code.
        if (UX.fancybox) {
            UX.fancybox(this.elements.abstractPreviewZoom);
            document.addEventListener('keydown', UX.fancyboxClose);
        }
    }

    onReady() {
        this.checkMenuItem(this.selectors.authorBio);
        this.checkMenuItem(this.selectors.bookReviews);

        if (this.elements.menuBookTab) {
            const menuBookTabFirstItem = this.elements.menuBookTab.querySelector('li:first-child a');
            menuBookTabFirstItem.click();
        }

        if (this.elements.readCubeSharing && this.elements.shareCtrl) {
            const parentEl = this.elements.shareCtrl.parentElement,
                shareAccessCtrl = parentEl?.querySelector(this.selectors.shareAccessCtrl),
                dropBlockHolder = parentEl?.querySelector(this.selectors.dropBlockHolder);

            this.elements.shareCtrl.classList.remove(this.classList.remove);
            shareAccessCtrl?.classList.add(this.classList.remove);
            dropBlockHolder?.setAttribute('aria-labelledby', 'share__ctrl');
        }
    }

    onLoad() {
        if (this.elements.tocAbstractPreview.length) {
            UX.utils.changeImageWidthOnLoad(this.selectors.tocAbstractPreview, 1.75);
        }
        UX.utils.fallbackImageViewer();
    }

    checkMenuItem = id => {
        const target = document.querySelector(`${id}-pane`);
        if (!target) {
            const targetEl = UX.utils.convertToArray(document.querySelectorAll(id));
            if (targetEl.length) {
                targetEl.forEach(item => {
                    const parentEl = item?.parentElement;
                    parentEl.removeChild(item);
                });
            }
        }
    };
}
